import gql from 'graphql-tag'

export const UPDATE_SETTING = gql`
  mutation ($input: UpdateSettingInput!) {
    updateSetting(input: $input) {
      setting {
        id
      }
    }
  }
`

export default {
  UPDATE_SETTING
}
